var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataBlock"},[_c('v-date-picker',{staticClass:"datePicker calendarDate",attrs:{"width":"100%","color":"green","prev-icon":"mdi-menu-left","next-icon":"mdi-menu-right","value":_vm.dateValue,"no-title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }